// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header背景样式 - 清晰显示图片版本（无遮罩） */
.header-background-clean {
  background: 
    /* 几乎透明的遮罩，仅保证文字可读性 */
    linear-gradient(135deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.05) 50%, rgba(0, 0, 0, 0.1) 100%);
  background-size: cover;  /* 使用cover确保图片完整显示且保持比例 */
  background-position: left center;  /* 左对齐居中，确保左边内容优先显示 */
  background-repeat: no-repeat;
  background-attachment: scroll;
  position: relative;
  /* 完全移除模糊效果 */
  backdrop-filter: none;
  /* 确保GIF动图能正常播放 */
  image-rendering: auto;
  -webkit-image-rendering: auto;
}

/* 完全隐藏网格效果 */
.header-background-clean::before {
  display: none;
}

/* 完全隐藏扫描线效果 */
.header-background-clean::after {
  display: none;
}

/* 让Header文字在纯图片背景下仍然可读 */
.header-background-clean .header-title {
  text-shadow: 
    3px 3px 6px rgba(0, 0, 0, 0.9),
    0 0 12px rgba(0, 0, 0, 0.8),
    0 0 20px rgba(0, 0, 0, 0.6);
  transition: all 0.3s ease;
  color: #fff !important; /* 强制白色 */
}

.header-background-clean .header-title:hover {
  text-shadow: 
    3px 3px 8px rgba(0, 0, 0, 0.9),
    0 0 15px rgba(0, 0, 0, 0.8),
    0 0 25px rgba(255, 255, 255, 0.4);
  transform: scale(1.05);
  color: #fff !important;
}

.header-background-clean .header-logo {
  filter: 
    drop-shadow(3px 3px 6px rgba(0, 0, 0, 0.9))
    drop-shadow(0 0 12px rgba(0, 0, 0, 0.6))
    brightness(1.2)
    contrast(1.3);
  transition: all 0.3s ease;
}

.header-background-clean .header-logo:hover {
  filter: 
    drop-shadow(4px 4px 8px rgba(0, 0, 0, 0.9))
    drop-shadow(0 0 16px rgba(0, 0, 0, 0.8))
    brightness(1.3)
    contrast(1.4);
  transform: scale(1.05) rotate(2deg);
}

/* 移动设备优化 - 确保图片左边内容完整显示 */
@media (max-width: 768px) {
  .header-background-clean {
    background-size: cover;  /* 保持cover确保图片完整显示 */
    background-position: left center;  /* 严格左对齐 */
    background-attachment: scroll;  /* 移动设备性能优化 */
  }
}

@media (max-width: 480px) {
  .header-background-clean {
    /* 小屏幕设备：优先显示图片左边内容 */
    background-size: auto 100%;  /* 高度100%，宽度自适应保持比例 */
    background-position: left center;  /* 强制左对齐 */
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/headerBackgroundClean.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE;;oGAEkG;EAClG,sBAAsB,GAAG,yBAAyB;EAClD,gCAAgC,GAAG,qBAAqB;EACxD,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,aAAa;AACb;EACE,aAAa;AACf;;AAEA,cAAc;AACd;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE;;;+BAG6B;EAC7B,yBAAyB;EACzB,sBAAsB,EAAE,SAAS;AACnC;;AAEA;EACE;;;qCAGmC;EACnC,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE;;;;iBAIe;EACf,yBAAyB;AAC3B;;AAEA;EACE;;;;iBAIe;EACf,mCAAmC;AACrC;;AAEA,0BAA0B;AAC1B;EACE;IACE,sBAAsB,GAAG,oBAAoB;IAC7C,gCAAgC,GAAG,UAAU;IAC7C,6BAA6B,GAAG,aAAa;EAC/C;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,0BAA0B,GAAG,qBAAqB;IAClD,gCAAgC,GAAG,UAAU;EAC/C;AACF","sourcesContent":["/* Header背景样式 - 清晰显示图片版本（无遮罩） */\n.header-background-clean {\n  background: \n    /* 几乎透明的遮罩，仅保证文字可读性 */\n    linear-gradient(135deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.05) 50%, rgba(0, 0, 0, 0.1) 100%);\n  background-size: cover;  /* 使用cover确保图片完整显示且保持比例 */\n  background-position: left center;  /* 左对齐居中，确保左边内容优先显示 */\n  background-repeat: no-repeat;\n  background-attachment: scroll;\n  position: relative;\n  /* 完全移除模糊效果 */\n  backdrop-filter: none;\n  /* 确保GIF动图能正常播放 */\n  image-rendering: auto;\n  -webkit-image-rendering: auto;\n}\n\n/* 完全隐藏网格效果 */\n.header-background-clean::before {\n  display: none;\n}\n\n/* 完全隐藏扫描线效果 */\n.header-background-clean::after {\n  display: none;\n}\n\n/* 让Header文字在纯图片背景下仍然可读 */\n.header-background-clean .header-title {\n  text-shadow: \n    3px 3px 6px rgba(0, 0, 0, 0.9),\n    0 0 12px rgba(0, 0, 0, 0.8),\n    0 0 20px rgba(0, 0, 0, 0.6);\n  transition: all 0.3s ease;\n  color: #fff !important; /* 强制白色 */\n}\n\n.header-background-clean .header-title:hover {\n  text-shadow: \n    3px 3px 8px rgba(0, 0, 0, 0.9),\n    0 0 15px rgba(0, 0, 0, 0.8),\n    0 0 25px rgba(255, 255, 255, 0.4);\n  transform: scale(1.05);\n  color: #fff !important;\n}\n\n.header-background-clean .header-logo {\n  filter: \n    drop-shadow(3px 3px 6px rgba(0, 0, 0, 0.9))\n    drop-shadow(0 0 12px rgba(0, 0, 0, 0.6))\n    brightness(1.2)\n    contrast(1.3);\n  transition: all 0.3s ease;\n}\n\n.header-background-clean .header-logo:hover {\n  filter: \n    drop-shadow(4px 4px 8px rgba(0, 0, 0, 0.9))\n    drop-shadow(0 0 16px rgba(0, 0, 0, 0.8))\n    brightness(1.3)\n    contrast(1.4);\n  transform: scale(1.05) rotate(2deg);\n}\n\n/* 移动设备优化 - 确保图片左边内容完整显示 */\n@media (max-width: 768px) {\n  .header-background-clean {\n    background-size: cover;  /* 保持cover确保图片完整显示 */\n    background-position: left center;  /* 严格左对齐 */\n    background-attachment: scroll;  /* 移动设备性能优化 */\n  }\n}\n\n@media (max-width: 480px) {\n  .header-background-clean {\n    /* 小屏幕设备：优先显示图片左边内容 */\n    background-size: auto 100%;  /* 高度100%，宽度自适应保持比例 */\n    background-position: left center;  /* 强制左对齐 */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
